import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';
import { CollaborativeAgreementSigned } from './collaborativeAgreements';


export type CollaborativePhysicianMatch = {
  id: string;
  collaborativePhysicianId: string;
  providerId: string;
  stateId: string;
};


export const getAllCollaborativePhysicians = () => restClient.request<{
  data: {
    providerId: string;
    supportedStateIds: string[];
  }[];
}>('/api/v1/admin/collaborative_physician/physicians');


export const getAllCollaborativePhysicianMatch = (matchId: string) => restClient.request<{
  data: CollaborativePhysicianMatch;
}>(`/api/v1/admin/collaborative_physician/match/${matchId}`);


export const getCollaborativePhysicianMatchesForPhysician = (collaborativePhysicianId: string) => restClient.request<{ data: CollaborativePhysicianMatch[] }>(
  `/api/v1/physician/${collaborativePhysicianId}/collaborative_physician/matches`
);

export const getCollaborativePhysicianMatchesForProvider = (providerId: string) => restClient.request<{ data: CollaborativePhysicianMatch[] }>(
  `/api/v1/provider/${providerId}/collaborative_physician/matches`
);

export type CreateCollaborativePhysicianParams = Omit<CollaborativePhysicianMatch, 'id'>;
export const createCollaborativePhysicianMatch = (params: CreateCollaborativePhysicianParams) => restClient.request<{ data: CollaborativePhysicianMatch[] }>(
  '/api/v1/admin/collaborative_physician/match', {
    method: 'POST',
    data: snakecaseKeys(params),
  }
);


export type DeleteCollaborativePhysicianParams = Pick<CollaborativePhysicianMatch, 'providerId' | 'stateId'>;
export const deleteCollaborativePhysicianMatch = (params: DeleteCollaborativePhysicianParams) => restClient.request<{ data: CollaborativePhysicianMatch[] }>(
  '/api/v1/admin/collaborative_physician/match', {
    method: 'DELETE',
    data: snakecaseKeys(params),
  }
);


export const getCollaborativePhysicianMatchAgreement = (matchId: string) => restClient.request<{ data: CollaborativeAgreementSigned }>(
  `/api/v1/admin/collaborative_physician/match/${matchId}/agreement`
);
